export default __webpack_public_path__ + "static/media/200_it.cb62567b.xls";